import React, {useEffect, useState} from 'react'
import {UserOutlined} from "@ant-design/icons"
import {Button, Menu, Dropdown} from "antd";


const UserMenu = () => {
    const [user, setUser] = useState({})

    useEffect(() => {
        let name = localStorage.getItem('name')
        let surname = localStorage.getItem('surname')
        setUser({name: name, surname: surname})
    }, [])


    const handleLogOutClick = () => {
        localStorage.removeItem('name')
        localStorage.removeItem('surname')
        localStorage.removeItem('mySweetApple')
        window.location = "/"
    }

    const menu = (
        <Menu>
            <Menu.Item key="1">
                <Button
                    type={'link'}
                    danger
                    onClick={handleLogOutClick}
                >
                    Çıkış Yap
                </Button>
            </Menu.Item>
        </Menu>
    )

    return (
        <React.Fragment>
            <div className={"user-dropdown"}>
                <div className={""}>
                    <Dropdown overlay={menu}>
                        <Button type={'text'}>
                            <UserOutlined/>
                            <span>{`${user.name} ${user.surname}`}</span>
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </React.Fragment>
    )
}
export default UserMenu